<template>
  <div>
    <div class="assistant_icon">
      <svg id="Group_27820" data-name="Group 27820" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 90.8 110.146"
        :class="[{ 'animated_icon': isAnimatedIcon }]">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_11564" data-name="Rectangle 11564" width="37.866" height="38.683" fill="#fff" />
          </clipPath>
        </defs>
        <g id="Group_27773" data-name="Group 27773" transform="translate(0 43.146)">

          <path id="Subtraction_1" data-name="Subtraction 1"
            d="M4.331,46.493a.619.619,0,0,1-.34-.091,1.226,1.226,0,0,1-.4-.94L4.616,34.313A21.12,21.12,0,0,1,15.776.7a21.129,21.129,0,1,1,5.347,41.571,20.979,20.979,0,0,1-7.279-1.3L5.052,46.277A1.67,1.67,0,0,1,4.331,46.493ZM21.919,18.559a2.4,2.4,0,1,0,0,4.808h0a2.4,2.4,0,0,0,0-4.81Zm-8.865,0a2.4,2.4,0,1,0,0,4.808h0a2.4,2.4,0,0,0,0-4.808Zm17.73,0a2.405,2.405,0,1,0,2.4,2.4A2.407,2.407,0,0,0,30.783,18.559Z"
            transform="translate(18.641 10.658)" :fill="primaryColor" stroke="rgba(0,0,0,0)" stroke-miterlimit="10"
            stroke-width="1" />

          <path id="Path_86977" data-name="Path 86977"
            d="M68.305,17.636l-.036-.072a32.062,32.062,0,0,0-57.015-.337C4.559,20.035,0,25.587,0,31.98s4.556,11.941,11.248,14.75a4.654,4.654,0,0,0,1.3.3c1.053.044,1.778-.753,1.44-1.4A29.425,29.425,0,0,1,18.741,11.86l.107-.127A29.1,29.1,0,1,1,43.509,60.9a4.256,4.256,0,1,0,.281,2.932,32.106,32.106,0,0,0,24.479-17.3c.04-.079.079-.159.118-.239,6.154-2.925,10.268-8.237,10.268-14.305,0-6.1-4.152-11.427-10.351-14.344"
            transform="translate(0 0.001)" :fill="headSetColor" />

        </g>
        <g id="Group_27763" data-name="Group 27763" transform="translate(52.934)" clip-path="url(#clip-path)">
          <path id="Path_86979" data-name="Path 86979"
            d="M0,9.891C5.562,9.006,8.992,5.811,10.147,0,11.3,5.8,14.688,9.014,20.288,9.9c-5.567.886-8.962,4.083-10.126,9.853C9,14.013,5.63,10.742,0,9.891"
            transform="translate(0 0)" :fill="primaryColor" />
          <path id="Path_86980" data-name="Path 86980"
            d="M29.632,26.04a8.582,8.582,0,0,0-7.07-7.344,8.6,8.6,0,0,0,7.067-7.319c.762,4.037,3.1,6.431,7.269,7.338-4.159.9-6.507,3.286-7.266,7.325"
            transform="translate(0.968 0.489)" :fill="primaryColor" />
          <path id="Path_86981" data-name="Path 86981"
            d="M7.607,31.508a7.456,7.456,0,0,0,5.809-6.085,7.374,7.374,0,0,0,6.117,6.1,7.334,7.334,0,0,0-6.1,6.065,7.454,7.454,0,0,0-5.822-6.083"
            transform="translate(0.326 1.091)" :fill="primaryColor" />
        </g>
      </svg>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 40
    },
    height: {
      type: Number,
      default: 40
    },
    autoSpin: {
      type: Boolean,
      default: false
    },
    spinDuration: {
      type: Number,
      default: null
    },
    themeSettings: {
      type: Object,
      default: null
    },
    bgColor: {
      type: String,
      default: '#000'
    },
  },
  data() {
    return {
      primaryColor: window.primaryColor,
      isAnimatedIcon: false,
      headSetColor: '#000',
      iconDots: '#fff',
    }
  },


  mounted() {
    if (this.autoSpin && this.spinDuration) {
      console.log(this.spinDuration)
      setInterval(() => {
        this.isAnimatedIcon = !this.isAnimatedIcon;
      }, this.spinDuration);
    }
  },
}
</script>
<style lang="less" scoped>
.assistant_icon svg {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  display: block;
  cursor: pointer;
}

.animated_icon {
  animation: rotate 550ms ease;
}

@keyframes rotate {
  0% {
    transform: rotate(-360deg);
    transition: transform 550ms ease;
  }

  100% {
    transform: rotate(360deg);
    transition: transform 550ms ease;
  }
}
</style>
